import I18n from 'i18n-js'

export const LOCALISED_FIELDS = ['name', 'description'] as const

export type LocalisedField = typeof LOCALISED_FIELDS[number]

// Matches a partner segment's flat localised attributes (name_en, description_nl,
// …) for any two-letter locale — as opposed to the localised_names /
// localised_descriptions hashes firm segments use.
export const FLAT_LOCALISED_ATTRIBUTE = new RegExp(
  `^(${LOCALISED_FIELDS.join('|')})_[a-z]{2}$`
)

const LOCALISED_KEYS = {
  name: 'localised_names',
  description: 'localised_descriptions',
} as const

export type LocalisedKey = typeof LOCALISED_KEYS[LocalisedField]

export function currentLocale(): string {
  return (I18n.locale || 'en').slice(0, 2)
}

export function localisedKeyFor(field: LocalisedField): LocalisedKey {
  return LOCALISED_KEYS[field]
}
